import { render, staticRenderFns } from "./order-evaluate.vue?vue&type=template&id=3d38f220&scoped=true"
import script from "./order-evaluate.vue?vue&type=script&lang=js"
export * from "./order-evaluate.vue?vue&type=script&lang=js"
import style0 from "./order-evaluate.vue?vue&type=style&index=0&id=3d38f220&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38f220",
  null
  
)

export default component.exports